var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-30 container",attrs:{"id":"Error404"}},[_c('h1',[_vm._v("404")])])}]

export { render, staticRenderFns }